var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{attrs:{"no-shadow":""}},[_c('e-charts',{ref:"pie",attrs:{"autoresize":"","options":_vm.pie,"auto-resize":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }